import { ModuleFormSource } from '../../module/form/ModuleFormSource.ts';
import {
  type ISignatureModalButtonProps,
  SignatureModalButton,
} from '../signer/signature/SignatureModalButton.tsx';
import { useSummarySource } from './SummarySourceContext.tsx';

/**
 * `SignatureModalButton` per le viste di riepilogo: si mostra solo nel
 * Backoffice, così il gate non va ripetuto su ogni cella azioni.
 */
export function SummarySignatureModalButton(
  props: Readonly<ISignatureModalButtonProps>,
) {
  const isBackoffice = useSummarySource() === ModuleFormSource.BACKOFFICE;
  if (!isBackoffice) return null;

  return <SignatureModalButton {...props} />;
}
